import * as React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { useCallback } from 'react';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import gtm from '@/utils/gtm';
import getLocal from 'eco-design-reliance/getLocal';
import AnimatedSection from '../../components/AnimatedSection';

const OnePicture: React.FC = () => {
    const { t } = useLang('OnePicture');
    const PRODUCT_IMAGE_URL_HAVE = 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg';
    getLocal();
    const items = [
        {
            title: t('title1'),
            desc: t('desc1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1774855934558/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1774855934558/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1774856004968/11.jpg',
            href: '#Output',
        },
        {
            title: t.rich('title2', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1774855934747/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1774855934747/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1774856005132/22.jpg',
            href: '#SectionImageText',
        },
        {
            title: t('title3'),
            desc: t('desc3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1774855935427/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1774855935427/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1774856005721/33.jpg',
            href: '#CompactAndPortable',
        },
        {
            title: t.rich('title4', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1774855935072/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1774855935072/4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1774856005537/44.jpg',
            href: '',
        },
        {
            title: t.rich('title5', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1774855935603/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1774855935603/5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1774856005338/55.jpg',
            href: '#LFP',
        },
        {
            title: t.rich('title6', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc6'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1774855935183/6.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1774855935183/6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1774856005931/66.jpg',
            href: '#Built',
        },
    ];

    const { isPad, isH5 } = useDeviceDetect();
    React.useEffect(() => {
        const imgHave = new Image();
        imgHave.crossOrigin = 'anonymous';
        imgHave.onload = () => {
            /* 预加载完成 */
        };
        imgHave.onerror = () => {
            /* 预加载失败 */
        };
        imgHave.src = PRODUCT_IMAGE_URL_HAVE;

        if (isPad || isH5) {
            const onePictureElm = document.getElementById('OnePicture');
            if (onePictureElm) onePictureElm.style.opacity = '1';
            return;
        }

        // 监听VideoFrame组件的进度事件
        const handleVideoProgress95 = (data: { progress: number }) => {
            console.log('OnePicture收到VideoFrame进度事件:', data.progress);
            setHaveProductImage(true);
        };

        EcoDesignEventsBus.on('videoProgress95', handleVideoProgress95);

        // 清理事件监听器
        return () => {
            EcoDesignEventsBus.off('videoProgress95', handleVideoProgress95);
        };
    }, [isPad, isH5]);

    const [haveProductImage, setHaveProductImage] = React.useState(false);

    const handleScrollInToView = useCallback((href: string) => {
        if (!href) return;

        const elementId = href.replace('#', '');
        const element = document.getElementById(elementId);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            const targetIdx = items.findIndex((item) => item.href === href);
            gtm.push({
                __btn_id1: `${styles.OnePicture} .item-${targetIdx + 1}`,
                __btn_id2: 'animated-section',
                __btn_type: 'common',
            });
        } else {
            console.warn(`Element with id "${elementId}" not found`);
        }
    }, []);

    return (
        <div className={`${styles.OnePictureDe} d3m-layout range1`} id="OnePicture">
            {/* PC Row1 / H5 全宽 item1 */}
            {isH5 && (
                <AnimatedSection
                    variant="rotateIn"
                    options={{ delay: 200 }}
                    onClick={() => handleScrollInToView(items[0].href || '')}
                    className="item item-h5-full"
                >
                    <EcoImg pc={items[0].pc} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />
                    <div className="text-wrapper">
                        <div className="title">{items[0].title}</div>
                        <div className="desc">{items[0].desc}</div>
                    </div>
                    <span className="item-link"></span>
                </AnimatedSection>
            )}

            {/* PC Row1：item1（左大）| [item2（上右）, item3（下右）] */}
            {/* H5 Row2：item2 + item3 并排 */}
            <div className="row-1">
                {!isH5 && (
                    <AnimatedSection
                        variant="rotateIn"
                        options={{ delay: 200 }}
                        onClick={() => handleScrollInToView(items[0].href || '')}
                        className="item row-1-left"
                    >
                        {!haveProductImage && <EcoImg key={1} pc={items[0].pc} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />}
                        {haveProductImage && <EcoImg key={2} pc={PRODUCT_IMAGE_URL_HAVE} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />}
                        <div className="text-wrapper">
                            <div className="title">{items[0].title}</div>
                            <div className="desc">{items[0].desc}</div>
                        </div>
                        <span className="item-link"></span>
                    </AnimatedSection>
                )}
                <div className="row-1-right">
                    <AnimatedSection
                        variant="rotateIn"
                        options={{ delay: 200 }}
                        onClick={() => handleScrollInToView(items[1].href || '')}
                        className="item row-1-right-top"
                    >
                        <EcoImg pc={items[1].pc} pad={items[1].pad} h5={items[1].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[1].title}</div>
                            <div className="desc">{items[1].desc}</div>
                        </div>
                        <span className="item-link"></span>
                    </AnimatedSection>
                    <AnimatedSection
                        variant="rotateIn"
                        options={{ delay: 200 }}
                        onClick={() => handleScrollInToView(items[2].href || '')}
                        className="item row-1-right-bottom"
                    >
                        <EcoImg pc={items[2].pc} pad={items[2].pad} h5={items[2].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[2].title}</div>
                            <div className="desc">{items[2].desc}</div>
                        </div>
                        <span className="item-link"></span>
                    </AnimatedSection>
                </div>
            </div>

            {/* PC Row2：[item4（左上）, item5（左下）] | item6（右大）*/}
            {/* H5：item4 全宽，item5 + item6 并排 */}
            {isH5 && (
                <AnimatedSection
                    variant="rotateIn"
                    options={{ delay: 200 }}
                    onClick={() => handleScrollInToView(items[3].href || '')}
                    className="item item-h5-full"
                >
                    <EcoImg pc={items[3].pc} pad={items[3].pad} h5={items[3].h5} isOpenLazy={true} />
                    <div className="text-wrapper">
                        <div className="title">{items[3].title}</div>
                        <div className="desc">{items[3].desc}</div>
                    </div>
                    {/* <div className="arrow"><Arrow /></div> */}
                </AnimatedSection>
            )}
            <div className="row-2">
                <div className="row-2-left">
                    {!isH5 && (
                        <AnimatedSection
                            variant="rotateIn"
                            options={{ delay: 200 }}
                            onClick={() => handleScrollInToView(items[3].href || '')}
                            className="item row-2-left-top"
                        >
                            <EcoImg pc={items[3].pc} pad={items[3].pad} h5={items[3].h5} isOpenLazy={true} />
                            <div className="text-wrapper">
                                <div className="title">{items[3].title}</div>
                                <div className="desc">{items[3].desc}</div>
                            </div>
                            {/* <div className="arrow"><Arrow /></div> */}
                        </AnimatedSection>
                    )}
                    <AnimatedSection
                        variant="rotateIn"
                        options={{ delay: 200 }}
                        onClick={() => handleScrollInToView(items[4].href || '')}
                        className="item row-2-left-bottom"
                    >
                        <EcoImg pc={items[4].pc} pad={items[4].pad} h5={items[4].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[4].title}</div>
                            <div className="desc">{items[4].desc}</div>
                        </div>
                        <span className="item-link"></span>
                    </AnimatedSection>
                </div>
                <AnimatedSection
                    variant="rotateIn"
                    options={{ delay: 200 }}
                    onClick={() => handleScrollInToView(items[5].href || '')}
                    className="item row-2-right"
                >
                    <EcoImg pc={items[5].pc} pad={items[5].pad} h5={items[5].h5} isOpenLazy={true} />
                    <div className="text-wrapper">
                        <div className="title">{items[5].title}</div>
                        <div className="desc">{items[5].desc}</div>
                    </div>
                    <span className="item-link"></span>
                </AnimatedSection>
            </div>
        </div>
    );
};

export default OnePicture;
